import { fetchAuthSession } from 'aws-amplify/auth';

const API_BASE_URL = 'https://89qp46aur6.execute-api.eu-west-1.amazonaws.com/dev';

export const apiCall = async (endpoint, options = {}) => {
  try {
    // Get the current user's JWT token using the new Amplify v6 syntax
    // This automatically refreshes the token if expired (using refresh token)
    const session = await fetchAuthSession();
    // Use idToken for API Gateway Cognito Authorizer (not accessToken)
    const token = session.tokens?.idToken?.toString();
    
    if (!token) {
      // Session expired completely - user needs to login again
      throw new Error('No authentication token available. Please login again.');
    }
    
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        ...options.headers,
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      // Try to get error details from response body
      let errorMessage = `HTTP error! status: ${response.status}`;
      let errorDetails = null;
      
      try {
        const errorData = await response.json();
        console.error('API Error Details:', errorData);
        
        // Extract error details
        if (errorData.details) {
          errorDetails = errorData.details;
        }
        
        // Extract error message from different formats
        if (errorData.error) {
          errorMessage = errorData.error;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (e) {
        // Response body is not JSON or empty
        console.error('Could not parse error response:', e);
      }
      
      // Handle authorization errors
      if (response.status === 401) {
        throw new Error('Unauthorized - Please login again');
      }
      if (response.status === 403) {
        throw new Error('Forbidden - You do not have permission for this action');
      }
      
      // Create error with details
      const error = new Error(errorMessage);
      if (errorDetails) {
        error.details = errorDetails;
      }
      throw error;
    }

    return await response.json();
  } catch (error) {
    console.error('API call failed:', error);
    
    // If token expired, redirect to login
    if (error.message.includes('login again') || error.message.includes('Unauthorized')) {
      // You can add logic here to redirect to login page
      // window.location.href = '/';
    }
    
    throw error;
  }
};